// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {addCommentItem, getCommentItem, userId} from '../../actions/userActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/user/CommentForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.user.getCommentItem,
        userValue: state.app.currentUser,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    setUserId: (id) => {
        return(dispatch(userId(id)))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let states = getState()
        let userId;

        if(states.user.userId)
            userId = states.user.userId

        else{
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'تکنسین وجود ندارد'
            })
        }

        var formData = {
            'customer_review'  : values.customer_review,
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('user/comment/'+userId, formData).then(list => {
            dispatch(addCommentItem(list.data.lists));
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}


export const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('user/'+id).then(commentInfo => {
            dispatch(getCommentItem(commentInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
